import { render, staticRenderFns } from "./PdfJsViewer.vue?vue&type=template&id=70e63966&"
import script from "./PdfJsViewer.vue?vue&type=script&lang=js&"
export * from "./PdfJsViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70e63966')) {
      api.createRecord('70e63966', component.options)
    } else {
      api.reload('70e63966', component.options)
    }
    module.hot.accept("./PdfJsViewer.vue?vue&type=template&id=70e63966&", function () {
      api.rerender('70e63966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PdfJsViewer.vue"
export default component.exports